import React from "react";

/**
 * Ace Behavioral Health brand mark + wordmark.
 * `variant`: "light" (default, dark ink) or "dark" (white ink for photo backgrounds).
 * `showTagline` renders the "Florida SNF & ALF · CRM" subline.
 */
export default function Logo({ variant = "light", showTagline = false, size = "md", className = "" }) {
  const isDark = variant === "dark";
  const ink = isDark ? "#FFFFFF" : "#0F172A";
  const accent = isDark ? "#FFFFFF" : "#0F172A";
  const soft = isDark ? "rgba(255,255,255,0.14)" : "#F1F5F9";

  const dims = {
    sm: { mark: 32, title: "text-lg", tag: "text-[10px]" },
    md: { mark: 44, title: "text-2xl", tag: "text-[11px]" },
    lg: { mark: 56, title: "text-3xl", tag: "text-xs" },
  }[size] || { mark: 44, title: "text-2xl", tag: "text-[11px]" };

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <svg width={dims.mark} height={dims.mark} viewBox="0 0 48 48" fill="none" aria-hidden="true">
        <rect x="1" y="1" width="46" height="46" rx="10" fill={soft} stroke={accent} strokeOpacity={isDark ? 0.35 : 0.15} />
        {/* Stylized "A" formed by two strokes + a heartbeat crossbar */}
        <path d="M14 34 L23 12 L32 34" stroke={ink} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        <path d="M17.5 27 L21 27 L22.5 24 L24.5 30 L26 27 L28.5 27" stroke={ink} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" opacity={isDark ? 0.9 : 0.85} />
      </svg>
      <div className="flex flex-col leading-none">
        <div className={`font-heading font-black tracking-tight ${dims.title}`} style={{ color: ink }}>
          Ace Behavioral Health
        </div>
        {showTagline && (
          <div
            className={`font-mono-plex uppercase tracking-[0.18em] mt-1.5 ${dims.tag}`}
            style={{ color: isDark ? "rgba(255,255,255,0.72)" : "#64748B" }}
          >
            Florida · SNF & ALF Intelligence
          </div>
        )}
      </div>
    </div>
  );
}
